import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
	'resize-handler-outer': {
		...shorthands.flex(0, 0, '0.45em'),
		...shorthands.outline('none'),
		'position': 'relative',
		'backgroundColor': tokens.colorTransparentBackground,

		'& [data-resize-handle-active]': {
			backgroundColor: 'rgb(255,255,255,0.2)',
		},
	},
});

export default useStyles;
